"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const client_1 = require("@apollo/client");
// //
// // assets
// //
const graphql_1 = require("./graphql");
//
// styles
//
const StyledInputContainer_1 = require("components/Dashboard/Account/StyledInputContainer");
const StyledInvalidFeedback_1 = require("components/Dashboard/StyledInvalidFeedback");
const AccountContext_1 = require("contexts/AccountContext");
const LocalAccount_1 = __importDefault(require("LocalAccount"));
const react_bootstrap_1 = require("react-bootstrap");
const polaris_1 = require("@shopify/polaris");
const lodash_1 = require("lodash");
const Overview = () => {
    const { account, setAccount } = (0, AccountContext_1.useAccount)();
    const { id: accountId } = account || { id: null };
    const [accountName, setAccountName] = (0, react_1.useState)(() => account === null || account === void 0 ? void 0 : account.name);
    const [defaultTrackingPageUrl, setDefaultTrackingPageUrl] = (0, react_1.useState)(() => account === null || account === void 0 ? void 0 : account.defaultTrackingPageUrl);
    const [subdomain, setSubdomain] = (0, react_1.useState)(() => account === null || account === void 0 ? void 0 : account.primaryHostedDomain.token);
    const [buttonStatus, setButtonStatus] = (0, react_1.useState)('');
    const [updateAccount, { data: updateAccountData, loading: updateAccountLoading, error: updateAccountError }] = (0, client_1.useMutation)(graphql_1.UPDATE_ACCOUNT);
    function handleUpdateAccount() {
        setButtonStatus('Loading...');
        const input = {
            id: LocalAccount_1.default.getId(),
            name: accountName,
            defaultTrackingPageUrl: defaultTrackingPageUrl || null
        };
        updateAccount({
            variables: {
                input
            }
        });
    }
    // when the account changes, update the form to use the new account values
    (0, react_1.useEffect)(() => {
        setAccountName(account === null || account === void 0 ? void 0 : account.name);
        setDefaultTrackingPageUrl(account === null || account === void 0 ? void 0 : account.defaultTrackingPageUrl);
        setSubdomain(account === null || account === void 0 ? void 0 : account.primaryHostedDomain.token);
    }, [accountId, account]);
    (0, react_1.useEffect)(() => {
        if (updateAccountData) {
            // if update successful, overwrite with latest data
            setAccountName(updateAccountData.updateAccount.account.name);
            setDefaultTrackingPageUrl(updateAccountData.updateAccount.account.defaultTrackingPageUrl);
            setSubdomain(updateAccountData.updateAccount.account.primaryHostedDomain.token);
            setAccount(updateAccountData.updateAccount.account);
            // LocalAccount should no longer be necessary when we start using the
            // account context, but for now there's some duplication
            LocalAccount_1.default.set(updateAccountData.updateAccount.account);
            setButtonStatus('Success!');
            setTimeout(() => {
                setButtonStatus('');
            }, 5000);
        }
        if (updateAccountError) {
            setButtonStatus('');
        }
    }, [updateAccountData, updateAccountError]);
    const validationErrors = (0, react_1.useMemo)(() => updateAccountError === null || updateAccountError === void 0 ? void 0 : updateAccountError.graphQLErrors.reduce((acc, { extensions }) => {
        return Object.assign(Object.assign({}, acc), { [extensions === null || extensions === void 0 ? void 0 : extensions.field]: extensions === null || extensions === void 0 ? void 0 : extensions.message });
    }, {}), [updateAccountError]);
    function displayApiError(error) {
        // no need to display validation errors twice, they are already displayed on
        // the fields themselves
        if (!(0, lodash_1.isEmpty)(validationErrors)) {
            return null;
        }
        if (error.message === 'Failed to fetch') {
            return 'The server could not be reached, please try again later';
        }
        return error.message;
    }
    return (react_1.default.createElement(react_bootstrap_1.Fade, { appear: true, in: true },
        react_1.default.createElement(StyledInputContainer_1.StyledInputContainer, null,
            react_1.default.createElement(polaris_1.FormLayout, null,
                react_1.default.createElement(polaris_1.TextField, { autoComplete: 'off', disabled: updateAccountLoading, error: validationErrors === null || validationErrors === void 0 ? void 0 : validationErrors.name, id: 'account-name', label: 'Account Name', onChange: (value) => setAccountName(value), value: accountName }),
                react_1.default.createElement(polaris_1.TextField, { autoComplete: 'off', disabled: updateAccountLoading, error: validationErrors === null || validationErrors === void 0 ? void 0 : validationErrors.default_tracking_page_url, id: 'default-tracking-page-url', label: 'Default Tracking Page URL', onChange: (value) => setDefaultTrackingPageUrl(value), value: defaultTrackingPageUrl || '' }),
                react_1.default.createElement(polaris_1.TextField, { autoComplete: 'off', disabled: true, id: 'subdomain', label: 'Subdomain', onChange: (value) => setSubdomain(value), value: subdomain }),
                react_1.default.createElement(polaris_1.Button, { disabled: updateAccountLoading, id: 'account-button', onClick: handleUpdateAccount, primary: true }, buttonStatus ? buttonStatus : 'Update Account')),
            updateAccountError ? (react_1.default.createElement(StyledInvalidFeedback_1.StyledInvalidFeedback, { className: 'api-error invalid-feedback' }, displayApiError(updateAccountError))) : null)));
};
exports.default = Overview;
